import Item from './Item';
import {inherits} from 'vega-util';

export default function GroupItem(mark) {
  Item.call(this, mark);
  this.items = (this.items || []);
}

inherits(GroupItem, Item);



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/GroupItem.js
// module id = 420
// module chunks = 0